module.exports = __webpack_public_path__ + "img/730-421285.png";